let apiUrl = process.env.REACT_APP_API_URL;
// let apiUrl = "https://api.grooveguide.io/";


const environment = {
  api: apiUrl,
  sasurl: process.env.REACT_APP_STORAGE_URL,
  frontendUrl: process.env.REACT_APP_FRONTEND_URL,
  container: process.env.REACT_APP_CONTAINER,
  cloverToken:process.env.REACT_APP_CLOVER_TOKEN,
  cloverAccessToken:process.env.REACT_APP_CLOVER_ACCESS_TOKEN,
  cloverId:process.env.REACT_APP_CLOVER_ID,
  OPENAI_API_KEY: process.env.REACT_APP_OPENAI_API_KEY,
  map_api_key: process.env.REACT_APP_MAP_API_KEY,
  apiUrl: apiUrl,
  userRoleId: process.env.REACT_APP_USER_ROLE_ID,
  customerSupportCategoryId: process.env.REACT_APP_CUSTOMER_SUPPORT_CATEGORY_ID,
  adminRoleId:process.env.REACT_APP_ADMIN_ROLE_ID,
  secretKey: process.env.REACT_APP_SECRET_KEY||'dg$4Fsdsdsdssd',
  env: process.env.REACT_APP_ENV||'live',
  recordingUrl:'https://api.grooveguide.io/eva/recordings' || process.env.REACT_RECORDING_URL 
};

export default environment;
